import React, { useEffect } from 'react';
import { SelectInput, useGetOne, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

const THIRD_PARTY_SUPPLIERS = ['Fastlane', 'Serview', 'ETC'];

const getResourceId = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'object') {
    return value['@id'] || value.id || null;
  }

  return value;
};

export const SupplierInput = ({
  company,
  source = 'supplier',
  companySupplier,
  currentSupplier,
  initializeDefault = false,
  ...props
}) => {
  const record = useRecordContext();
  const { getValues, setValue } = useFormContext();
  const companyId = getResourceId(company);
  const { data: companyRecord } = useGetOne(
    'companies',
    { id: companyId },
    { enabled: Boolean(companyId) }
  );
  const defaultSupplier =
    currentSupplier ||
    record?.supplier ||
    companySupplier ||
    companyRecord?.name ||
    null;
  const shouldInitializeDefault =
    initializeDefault ||
    (!currentSupplier && !record?.supplier);
  const supplierNames = [
    companyRecord?.name,
    companySupplier,
    currentSupplier,
    record?.supplier,
    ...THIRD_PARTY_SUPPLIERS,
  ].filter(
    (name, index, values) => name && values.indexOf(name) === index
  );

  useEffect(() => {
    if (
      shouldInitializeDefault &&
      defaultSupplier &&
      !getValues(source)
    ) {
      setValue(source, defaultSupplier, { shouldDirty: false });
    }
  }, [
    defaultSupplier,
    getValues,
    setValue,
    shouldInitializeDefault,
    source,
  ]);

  return (
    <SelectInput
      {...props}
      fullWidth
      required
      source={source}
      label="Supplier"
      choices={supplierNames.map((name) => ({ id: name, name }))}
      defaultValue={
        shouldInitializeDefault ? defaultSupplier : undefined
      }
    />
  );
};

export const SupplierFilter = ({ company, ...props }) => {
  const companyId = getResourceId(company);
  const { data: companyRecord, isPending } = useGetOne(
    'companies',
    { id: companyId },
    { enabled: Boolean(companyId) }
  );
  const supplierNames = [
    companyRecord?.name,
    ...THIRD_PARTY_SUPPLIERS,
  ].filter(Boolean);

  return (
    <SelectInput
      {...props}
      label="Supplier"
      source="supplier"
      choices={supplierNames.map((name) => ({ id: name, name }))}
      disabled={isPending}
    />
  );
};
